import React, { useEffect, useState } from 'react'
import ReportsApi from '../../../../api/ReportsApi'
import PieChart from 'components/PieChart/PieChart'
import { IReportFilter } from 'views/Reports'
import { useThemeStyling } from 'hooks/useThemeStyling/useThemeStyling';
import { AccentArea } from 'components'
/**
 * @name ByWinLoss
 * @desc Render 'Win/Loss'
 * @filterValues IReportsFilter
 */
const ByWinLoss = ({
    filterValues,
}: {
    filterValues: IReportFilter
}): React.ReactElement => {
    const { clientTheme } = useThemeStyling()
    const [loading, setLoading] = useState<boolean>(true)
    const [data, setData] = useState<{ name: string; value: number }[]>([])

    useEffect(() => {
        setLoading(true)
        ReportsApi.getByWinLoss(filterValues).then((data) => {
            setLoading(false)
            setData(data)
        })
    }, [filterValues]) // eslint-disable-line react-hooks/exhaustive-deps

    const colorPalette = clientTheme.charts.pieCharts.defaultPieChart

    return (
        <AccentArea title="Win/Loss">
            <PieChart
                data={data}
                loading={loading}
                colorPalette={colorPalette}
                showLegend={true}
                testId="byWinLoss"
            />
        </AccentArea>
    )
}

export default ByWinLoss
